import React from "react";
import PropTypes from "prop-types";
import { NOOP } from "../shared";

export function FormDate({ id = "", name = "", value = null, className = "", onChange = NOOP }) {
	const onUpdate = (event) => onChange(new Date(event.target.value));
	return (
		<input
			type="date"
			id={id}
			name={name}
			className={className}
			value={new Date(value).toISOString().substr(0, 10)}
			onChange={onUpdate}
		/>
	);
}

export function FormMonth({ id = "", name = "", value = null, className = "", onChange = NOOP }) {
	const onUpdate = (event) => onChange(new Date(event.target.value));
	return (
		<input
			type="month"
			id={id}
			name={name}
			className={className}
			value={new Date(value).toISOString().substr(0, 10)}
			onChange={onUpdate}
		/>
	);
}

FormMonth.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	value: PropTypes.instanceOf(Date),
	className: PropTypes.string,
	onChange: PropTypes.func
};


FormDate.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	value: PropTypes.instanceOf(Date),
	className: PropTypes.string,
	onChange: PropTypes.func
};

export default FormDate